import { render, staticRenderFns } from "./setMealSeries.vue?vue&type=template&id=0328c8ee&scoped=true"
import script from "./setMealSeries.vue?vue&type=script&lang=js"
export * from "./setMealSeries.vue?vue&type=script&lang=js"
import style0 from "./setMealSeries.vue?vue&type=style&index=0&id=0328c8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328c8ee",
  null
  
)

export default component.exports